<template>
  <div id="staff-rating" class="data-list-container vs-con-loading__container" v-if="config.pos_feature == 1">
    <div class="vx-breadcrumb mb-6">
      <ul class="flex flex-wrap items-center">
        <li class="inline-flex items-end">
          <router-link to="/after-login">
            <feather-icon
              icon="HomeIcon"
              svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            />
          </router-link>
          <span class="breadcrumb-separator mx-2 mr-1">
            <feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" />
          </span>
        </li>
        <li class="inline-flex items-end">
          <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Staff Rating</span>
        </li>
      </ul>
    </div>
    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow w-row mb-6 reward-header staff-rating-header justify-between">
      <div class="staff-rating-search con-input-search vs-table--search">
        <input type="text" class="input-search vs-table--search-input border-custom" placeholder="Search staff" @keyup="searchStaff">
        <i class="vs-icon notranslate icon-scale material-icons null">search</i>
      </div>
      <div class="flex align-center">
        <div class="select-view ml-4">
          <v-select @input="selectId($event)" :value="view_by" label="name" :options="viewOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
        </div>
        <div class="flex align-center date-picker-group ml-4">
            <vs-button color="white" class="leading-none calendar-icon-btn" @click="isOpenCalendar = !isOpenCalendar">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 15px; fill: #626262">
                    <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                </svg>
            </vs-button>
            <vs-button class="gradient gradient-primary no-shadow today-btn" @click="gotoToday">Today</vs-button>
            <date-picker class="filter-date-picker" range-separator="  to  " :format="date_format_string" v-model="filter_day" type="date" :editable = "false" :open.sync="isOpenCalendar"
            @close="isOpenCalendar = false" range placeholder="From date to date" :class="{'width-empty' : filter_day.length == 0, 'width-has-value' : filter_day.length != 0}" @change="filterDay"></date-picker>

            <vs-button color="white" class="leading-none close-icon-btn" @click="clearDayFilter">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 15px; fill: #626262">
                    <path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"></path>
                </svg>
            </vs-button>
        </div>
      </div>
    </div>
    <div class="service-list-content">
      <div class="service-header flex p-6 text-sm font-bold">
        <div class="w-1/6 px-2 center-title text-center">STAFF ID</div>
        <div class="w-1/4 px-2 center-title text-center">STAFF NAME</div>
        <div class="w-1/4 px-2 text-center">RATING</div>
        <div class="w-1/3 px-2 text-center">AVERAGE POINTS</div>
      </div>

      <!-- <div v-if="checkList() == true"> -->
      <div v-if="staffRatingList && staffRatingList.staffRatingList && staffRatingList.staffRatingList.length > 0">
        <transition-group>
          <div v-for="item in staffRatingList.staffRatingList" :key="item.id">
            <!-- <div class="service-item align-center p-5 mb-4 shadow-sm" v-if="parseFloat(item.average_point) != 0"> -->
            <div class="service-item align-center p-5 mb-4 shadow-sm">
              <div class="flex" @click="showDetailRating(item)">
                <div class="w-1/6 px-2">
                  <p class="product-name font-medium truncate service-name text-center font-bold" style="color:#000">{{item.staff_id}}</p>
                </div>
                <div class="w-1/4 px-2">
                  <p class="product-name font-medium truncate service-name text-center font-bold" style="color:#000">{{item.staff_name}}</p>
                </div>
                <div class="w-1/4 px-2">
                  <div class="text-center">
                    <star-rating :rtl="$vs.rtl" :star-size="20" :increment="0.1" :read-only="true" :show-rating="false" :rating="parseFloat(item.average_point)"/>
                  </div>
                </div>
                <div class="w-1/3 px-2">
                  <p class="product-name font-medium truncate service-name text-center font-bold" style="color:#626262">{{item.average_point}}</p>
                </div>
              </div>

              <div v-if="showDetail && id_show == item.id" class="mt-3">
                <hr class="mt-2">
                <div v-for="customer in item.customerList" :key="customer.id" class="flex">
                  <div class="w-1/6 px-2"></div>
                  <div class="w-1/2 px-2 mt-4 flex">
                    <p class="truncate combo-item w-1/3 font-bold" :class="{'text-primary cursor-pointer': customer.customer_id != null && customer.customer_id != undefined}" style="color:#626262" @click="openCustomerPopup(customer)">{{customer.customer_name}}</p>
                    <star-rating class="w-1/3" :rtl="$vs.rtl" :star-size="20" :increment="0.1" :read-only="true" :show-rating="false" :rating="parseFloat(customer.average_points)"/>
                    <p class="truncate combo-item w-1/3 font-bold" style="color:#8B8B8B">{{formatDate(customer.date_rating)}}</p>
                  </div>
                  <div class="w-1/3 px-2"></div>
                </div>
              </div>
            </div>
          </div>
        </transition-group>
        <customer-popup-content
          v-if="customer_key != 0"
          :popupConfig="popupCustomerConfig"
          :activeCustomer="activeCustomer"
          :key="customer_key + 'a'"
          @ClosePopup="popupCustomerConfig.isOpen = false"
          :isFromStaffRating="true"
        ></customer-popup-content>
      </div>
      <div v-else class="not-data-table vs-table--not-data">
        No data available
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { changeFormatWithDateTime, formatDateString } from '../../helper/datetimeHelper';
import StarRating from 'vue-star-rating'
import DatePicker from 'vue2-datepicker';
import vSelect from 'vue-select';
export default {
  components:{
    DatePicker,
    StarRating,
    vSelect
  },
  data(){
    let date_format_string = formatDateString();
    let viewOptions = [];
    viewOptions = this.getFilterOptions();
    let view_by = {
      id: 0,
      name: 'Day',
      type: 'day',
      start_date: moment().format(date_format_string),
      end_date: moment().format(date_format_string),
    };
    let startDate = moment().format(date_format_string);
    let endDate = moment().format(date_format_string);

    return{
      isOpenCalendar: false,
      date_format_string,
      filter_day: [],
      itemsPerPage: 10,
      showDetail: false,
      id_show: 0,
      startDate,
      endDate,
      search: '',
      viewOptions,
      view_by,
      action_type: '',
      isOpenLoading: false,
      active_filter: '',
      popupCustomerConfig: {
        isOpen: false
      },
      activeCustomer: {},
      customer_key: 0
    }
  },
  methods:{
    openLoadingInDiv(){
      this.$vs.loading({
        container: '#app',
        scale: 0.8
      })
      if(this.loadTime){
          clearTimeout(this.loadTime);
          this.loadTime = null;
      }
      this.isOpenLoading = true;
      this.loadTime = setTimeout( ()=> {
          if(this.isOpenLoading) {
              this.closeLoading();
              this.$vs.dialog({
                  color: 'danger',
                  title: 'Notification',
                  text: this.action_type + ' staff rating failed',
                  acceptText: 'OK'
              })
          }
      }, 10000);
    },
    closeLoading() {
      this.$vs.loading.close('#app > .con-vs-loading');
      this.isOpenLoading = false;
    },
    formatDate(date){
      if(date) {
        return changeFormatWithDateTime(date);
      } else {
        return 'N/A';
      }
    },
    checkList(){
      let key = 0;
      if(this.staffRatingList && this.staffRatingList.staffRatingList){
        for(let i = 0; i<this.staffRatingList.staffRatingList.length;i++){
          if(this.staffRatingList.staffRatingList[i].average_point != 0){
            key++;
          }
        }
      }
      if(key == 0){
        return false
      }
      return true;
    },
    gotoToday(){
      this.startDate = moment(new Date()).format('MM/DD/YYYY')
      this.endDate = moment(new Date()).format('MM/DD/YYYY')
      this.filter_day = [new Date(), new Date()]
      const obj = {
        start_date: this.startDate,
        end_date: this.endDate,
        keyword: this.search
      }
      this.active_filter = 'calendar';
      this.action_type = "Get list";
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST", obj).then(() => {
        this.showDetail = false;
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ' + err);
      });
    },
    filterDay(){
      if(this.filter_day && this.filter_day.length > 0) {
        this.startDate = moment(this.filter_day[0]).format('MM/DD/YYYY')
        this.endDate = moment(this.filter_day[1]).format('MM/DD/YYYY')
      }else{
        this.startDate = null
        this.endDate = null
      }
      const obj = {
        start_date: this.startDate,
        end_date: this.endDate,
        keyword: this.search
      }
      this.active_filter = 'calendar';
      this.action_type = "Get list";
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST", obj).then(() => {
        this.showDetail = false;
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ' + err);
      });
    },
    clearDayFilter() {
        this.filter_day = [];
        this.startDate = null;
        this.endDate = null;
        this.active_filter = 'calendar';
        this.action_type = "Get list";
        let obj = {
          keyword: this.search
        }
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST", obj).then(() => {
          this.showDetail = false;
          this.closeLoading();
        }).catch((err) => {
          console.log('Error: ' + err);
        });
    },
    showDetailRating(tr){
      if(tr.customerList && tr.customerList.length > 0){
        this.showDetail = !this.showDetail
        this.id_show = tr.id
      }
    },
    getFilterOptions() {
      let filterOptions = [];
      filterOptions.push({
          id: filterOptions.length + 1,
          name: 'Day',
          type: 'day',
          start_date: new Date(),
          end_date: new Date(),
      });
      filterOptions.push({
          id: filterOptions.length + 1,
          name: 'Week',
          type: 'week',
          start_date: new Date(moment().subtract(6, 'days').format(this.date_format_string)),
          end_date: new Date(moment().format(this.date_format_string)),
      });
      filterOptions.push({
          id: filterOptions.length + 1,
          name: '2 Weeks',
          type: '2weeks',
          start_date: new Date(moment().subtract(13, 'days').format(this.date_format_string)),
          end_date: new Date(moment().format(this.date_format_string)),
      });
      filterOptions.push({
          id: filterOptions.length + 1,
          name: 'Month',
          type: 'month',
          start_date: new Date(moment().subtract(29, 'days').format(this.date_format_string)),
          end_date: new Date(moment().format(this.date_format_string)),
      });

      return filterOptions;
    },
    selectId(e) {
      // console.log(e);
      this.view_by = JSON.parse(JSON.stringify(e));
      this.view_by.id = 0;
      // this.filter_day = [e.start_date, e.end_date]
      let data = {
        start_date: moment(e.start_date).format('MM/DD/YYYY'),
        end_date: moment(e.end_date).format('MM/DD/YYYY'),
        keyword: this.search
      }

      this.action_type = "Get list";
      this.active_filter = 'select';
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST", data).then(() => {
        this.closeLoading();
      }).catch((err) => {
        console.log('Error: ' + err);
      });
    },
    searchStaff({ target }) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      if (!this.isOpenLoading) {
        this.openLoadingInDiv();
      }

      this.timer = setTimeout(() => {
        this.search = target.value;
        const obj = {
          keyword: target.value,
        };
        if(this.active_filter == 'calendar' && this.startDate && this.endDate) {
          obj.start_date = this.startDate;
          obj.end_date = this.endDate;
        }
        if(this.active_filter == 'select') {
          obj.start_date = this.view_by.start_date;
          obj.end_date = this.view_by.end_date;
        }
        this.action_type = "Search";
        this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST", obj).then(() => {
          this.closeLoading();
        }).catch((err) => {
          console.log('Error: ' + err);
        });
      }, 500);
    },
    openCustomerPopup(customer) {
      if(customer && customer.customer_id != null && customer.customer_id != undefined) {
        this.action_type = 'Get customer info';
        if(!this.isOpenLoading) {
          this.openLoadingInDiv();
        }
        this.$store.dispatch('customerList/GET_A_CUSTOMER', { id: customer.customer_id }).then(() => {
          this.activeCustomer = this.$store.getters['customerList/customerInfo'];
          this.customer_key++;
          this.popupCustomerConfig.isOpen = true;
          this.closeLoading();
        }).catch((err) => {
          console.log('Error: ' + err);
        })
      }
    }
  },
  computed: {
    config() {
      return this.$store.getters["auth/config"];
    },
    staffRatingList(){
      return this.$store.getters["reviewList/staffRatingList"];
    }
  },
  created(){
    // let data = {
    //   start_date: moment().format('MM/DD/YYYY'),
    //   end_date: moment().format('MM/DD/YYYY')
    // }
    this.$store.dispatch("reviewList/GET_STAFF_RATING_LIST").then((res) => {
      this.filter_day = [new Date(res.start_date), new Date(res.end_date)];
    });
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/vuexy/_variables';
  #staff-rating {
    .custom-pagination {
      width: fit-content !important;
      margin: 0 auto;
    }
    .vs-table--content {
      overflow: unset;
    }
    .vs-con-tbody {
      margin-top: 20px;
      overflow: unset;
    }

    .trash-icon {
      width: 16px;
      height: 19.89px;
    }

    @media (max-width: 481px) {
      .vs-con-tbody {
        overflow: auto;
      }
    }
    .vs-con-table {
      .logic-num-font-size {
        font-size: 20px;
      }
      .text-uppercase{
        padding: 5px 0px;
        font-size: 10px;
        color: #9a9a9a;
        display: block;
        margin-bottom: 8px;
        text-transform: uppercase;
      }

      .prmotion-type{
        color: aqua
      }

      .product-name {
        padding-top:5px;
        max-width: 23rem;
      }

      .vs-table--header {
        display: flex;
        flex-wrap: wrap-reverse;
      //   margin-left: 1.5rem;
      //   margin-right: 1.5rem;
        > span {
          display: flex;
          flex-grow: 1;
        }

        .vs-table--search{
          padding-top: 0;

          .vs-table--search-input {
            padding: 0.9rem 2.5rem;
            font-size: 1rem;

            &+i {
              left: 1rem;
            }

            &:focus+i {
              left: 1rem;
            }
          }
        }
      }
      .vs-table {
        border-collapse: separate;
        border-spacing: 0 1.3rem;
        // padding: 0 1rem;
        font-size: 13px;
        tr{
            box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
            td{
              padding: 20px;
              &:first-child{
                border-top-left-radius: .5rem;
                border-bottom-left-radius: .5rem;
              }
              &:last-child{
                border-top-right-radius: .5rem;
                border-bottom-right-radius: .5rem;
              }
            }
            td.td-check{
              padding: 20px !important;
            }
        }
      }

      .vs-table--thead{
        th {
          padding-top: 0;
          padding-bottom: 0;
          font-size: 12px;
          .vs-table-text{
            text-transform: uppercase;
            font-weight: 600;
          }
        }
        th.td-check{
          padding: 0 15px !important;
          width:50px;
        }
        tr{
          background: none;
          box-shadow: none;
        }
      }

      .vs-table--pagination {
        justify-content: center;
      }
        vs-table {
          counter-reset: rowNumber;
        }

        vs-table vs-tr {
            counter-increment: rowNumber;
        }

        td .vs-table--td {
            content: counter(rowNumber);
            min-width: 1em;
            margin-right: 0.5em;
        }
    }

    .select-view {
      width: 140px;
      .v-select {
          height: 36px;
          .vs__dropdown-toggle {
              height: 100%;
              border-radius: 4px;
              background: #fff;
              border: 1px solid #ccc;

              .vs__selected {
                // color: $primary;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 3px;
                margin-right: 0;
                padding-left: 10px;
              }

              .vs__open-indicator {
                color: #AAA;
                padding-right: 2px;
              }
          }
          .vs__dropdown-menu {
            top: 110%;
            border-radius: 4px;
            border: 1px solid #ccc;
            padding: 0;
            min-width: unset;
            // overflow: hidden;
            &::-webkit-scrollbar, &::-webkit-scrollbar-track, &::-webkit-scrollbar-thumb {
              border-top-right-radius: 8px !important;
              border-bottom-right-radius: 8px !important;
            }

            li {
              padding-top: 8px;
              padding-bottom: 8px;
              padding-left: 16px;
              width: inherit;
              overflow-x: auto;
            }
          }
      }
    }
  }
  .service-item {
    background: #fff;
    border-radius: 8px;
    -webkit-transition: all 1s;
    transition: all 1s;
  }
  .staff-rating-search.vs-table--search {
      margin-left: 0px !important;
      max-width: unset;
  }
  .staff-rating-search.vs-table--search .vs-table--search-input {
    height: 36px !important;
    border-radius: 4px;
    border: 1px solid #ccc;
    width: 240px;
    font-size: 13px;
    &::placeholder {
      color: #ccc;
    }
  }
  #staff-rating .calendar-icon-btn {
      width: 36px;
      height: 36px;
      padding: 0;
      border: 1px solid #ccc;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
  }
  #staff-rating .today-btn {
      height: 36px;
      padding: 0 5px;
      border-radius: 0;
  }
  #staff-rating .staff-rating-header .filter-date-picker.mx-datepicker-range .mx-input {
      height: 36px;
      border-radius: 4px;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      box-shadow: none;
      font-size: 1rem;
      padding: 6px 20px;
      padding-right: 20px;
  }
  #staff-rating .staff-rating-header .filter-date-picker.mx-datepicker-range {
    width: 250px;
    .mx-icon-calendar, .mx-icon-clear {
        left: 16px;
        right: unset;
        display: none;
    }
  }
  #staff-rating .close-icon-btn {
      width: 36px;
      height: 36px;
      border-radius: 4px;
      padding: 0;
      border: 1px solid #ccc;
  }
  #staff-rating .vue-star-rating{
      display: unset !important;
      align-items: unset !important;
  }
</style>
